import React, { Component } from 'react';
import * as qs from 'query-string';

import { Http } from '../../support';
import Loading from '../../facturotopia/loading/Loading';
import ResponseError from '../../shared/responses/ResponseError';
import ResponseResult from '../../shared/responses/ResponseResult';

class LandingCompra extends Component {

  state = {
    data: {}
  }

  componentDidMount = async () => {
    const { id } = this.props.match.params;

    this.setState({
      busy: true
    });

    const query = qs.parse(this.props.location.search);

    const url = query.esquema === 'postpago'
      ? `api/compras/${id}/postpago`
      : `api/compras/${id}`;

    const params = {
      'retry': query.retry
    };

    try {
      const response = await Http.patch(url, params);

      this.setState({
        result: response
      });

    } catch (error) {
      const { redirect_url } = error.data;

      this.setState({
        error: error.data || error,
        redirect_url: redirect_url
      });
    } finally {
      this.setState({
        busy: false
      });
    }
  }

  handleOnAction = (action) => {
    if (action === 'reset') {
      const { redirect_url } = this.state.error;

      if (!!redirect_url) {
        window.location = redirect_url;
      } else {
        const { id } = this.props.match.params;

        this.props.history.replace({
          pathname: `/cuenta/historial-compra/${id}/info`,
        });
      }
    }

    if (action === 'success') {
      const query = qs.parse(this.props.location.search);

      if (!!query.intro) {
        this.props.history.replace('/app/intro');
      } else {
        this.props.history.replace('/cuenta/historial-compra');
      }
    }
  }

  renderError = () => {
    const { error } = this.state;

    return (
      <div className="result-container">
        <ResponseError
          title={ error.code === 'payment_3ds' ? 'Autenticación de tarjetas' : 'Error' }
          error={ error }
          btnText={ error.code === 'payment_3ds' ? 'Autentificar mi pago' : 'Ver detalles' }
          status={ error.code === 'payment_3ds' ? 'warning' : 'error' }
          onAction={ this.handleOnAction }
        />
      </div>
    );
  }

  renderResult = () => {
    const { result } = this.state;

    return (
      <div className="result-container">
        <ResponseResult
          title="Compra exitosa"
          result={ result }
          onAction={ this.handleOnAction }
        />
      </div>
    );
  }

  render() {
    const { busy, error, result } = this.state;

    return (
      <>
        { busy && <Loading /> }

        { busy && (
          <div className="py-5">
            <strong>Procesando tu compra, por favor espera</strong>
          </div>
        )}

        { !!result && this.renderResult() }

        { !!error && this.renderError() }
      </>
    )
  }
}

export default LandingCompra;